// extracted by mini-css-extract-plugin
export default {"appSidebar":"AppSidebar_appSidebar__8jJIn","closedSidebar":"AppSidebar_closedSidebar__bvDze","sidebar-section-header":"AppSidebar_sidebar-section-header__LPy90"};